import DataProtectionAgreementDialog from './DataProtectionAgreementDialog';

export * from './types';

export default DataProtectionAgreementDialog;
